import http from "../http-common";
import { getToken, getTokenBearer } from "../utils/Utils";

const getAll = () => {
    return http.get("/filters", {
        headers: {
            Authorization: `Bearer ${getToken()}`
        }
    });
};

const get = (id) => {
    return http.get(`/filters/${id}`, {
        headers: {
            Authorization: getTokenBearer()
        }
    });
};

const create = (data) => {
    return http.post(`/filters`, data, {
        headers: {
            Authorization: `Bearer ${getToken()}`
        }
    });
};

const update = (id, data) => {
    return http.put(`/filters/${id}`, data, {
        headers: {
            Authorization: getTokenBearer()
        }
    });
};

const remove = (id) => {
    return http.delete(`/filters/${id}`, {
        headers: {
            Authorization: getTokenBearer()
        }
    });
};

const authenticate = (user) => {
    return http.post(`/filters/auth/login`, user);
};

const loadRefernceTableInfo = (data) => {
    return http.post(`/filters/loadRefernceTableInfo`, data);
};

const FilterService = {
    getAll,
    get,
    create,
    update,
    remove,
    authenticate,
    loadRefernceTableInfo,
};

export default FilterService;
